import { Injectable } from '@angular/core';
import * as jwt_decode from 'jwt-decode';

@Injectable({
	providedIn: 'root'
})
export class SessionService {
	storage_key = 'gsviewer _session';

	constructor() { }

	getSessao(chave) {
		return new Promise((resolve) => {
			let sessao = JSON.parse(localStorage.getItem(this.storage_key))
			if (sessao != null) {
				let retorno = chave ? sessao[chave] : sessao;
				// resolve(retorno);
				resolve(true)
			}
			else {
				resolve(null);
			}
		});
	}
	getDadosSessao(){
		let sessao = JSON.parse(localStorage.getItem(this.storage_key))
		if(sessao != null){
			return sessao
		} else {
			return null
		}
	}

	remove_sessao(){
        localStorage.removeItem(this.storage_key);
    }

	getToken() {

		let sessao = JSON.parse(localStorage.getItem(this.storage_key))
		// console.log('sessao', sessao)
		if(sessao == null){
			return ''
		} else {
			return sessao['accessToken'];
		}
		// return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZG1pbkBlbWFpbC5jb20iLZTSXgi164MCGG3u5RKXaBGVBabmxQTVRAAVE5tDTDgxNn0.hpEQenPMJNuqUwhg5W8UMFs66YBXrBVhhZzMFyRJVME'
	}

	getAdm() {

		let sessao = JSON.parse(localStorage.getItem(this.storage_key))
		// console.log('sessao', sessao)
		if(sessao == null){
			return ''
		} else {
			return sessao['administrador'];
		}
		// return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZG1pbkBlbWFpbC5jb20iLZTSXgi164MCGG3u5RKXaBGVBabmxQTVRAAVE5tDTDgxNn0.hpEQenPMJNuqUwhg5W8UMFs66YBXrBVhhZzMFyRJVME'
	}

	getClienteUsuario() {

		let sessao = JSON.parse(localStorage.getItem(this.storage_key))
		// console.log('sessao', sessao)
		if(sessao == null){
			return ''
		} else {
			return sessao['cliente'];
		}
		// return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZG1pbkBlbWFpbC5jb20iLZTSXgi164MCGG3u5RKXaBGVBabmxQTVRAAVE5tDTDgxNn0.hpEQenPMJNuqUwhg5W8UMFs66YBXrBVhhZzMFyRJVME'
	}

	getId() {

		let sessao = JSON.parse(localStorage.getItem(this.storage_key))
		// console.log('sessao', sessao)
		if(sessao == null){
			return ''
		} else {
			return sessao['id'];
		}
		// return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZG1pbkBlbWFpbC5jb20iLZTSXgi164MCGG3u5RKXaBGVBabmxQTVRAAVE5tDTDgxNn0.hpEQenPMJNuqUwhg5W8UMFs66YBXrBVhhZzMFyRJVME'
	}


	setSessao(data) {
		let administrador = false
		for(var i in data['profiles']){
			if(data['profiles'][i] == 'admin' ){
				administrador = true
			}
		}
		let token = data['accessToken']
		let decoded = jwt_decode(token);
		data['id'] = decoded['sub']
		data['administrador'] = administrador
		localStorage.setItem(this.storage_key, JSON.stringify(data));
		// console.log('sessao',JSON.parse(localStorage.getItem(this.storage_key)))
	}

	
}
